var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:[
    'font-normal flex flex-col items-center justify-center cursor-pointer',
    'focus:outline-none border',
    _vm.classes,
    { 'pointer-events-none opacity-40': _vm.disabled } ],attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_c('span',{staticClass:"flex flex-row items-center justify-center",class:{ 'h-0 overflow-hidden': !_vm.busy }},[_vm._t("busy")],2),_c('span',{staticClass:"flex flex-row items-center justify-center",class:{ 'h-0 overflow-hidden': _vm.busy }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }